<app-dialog [size]="DialogSize.LARGE" [dataSelector]="dataSelector + '-container'">
  <!-- Dialog Header -->
  <app-dialog-header [dataSelector]="dataSelector + '-header'">Manage files linked to "{{ documentRequestTitle }}"</app-dialog-header>

  <span class="body-300" [dataSelector]="dataSelector + '-description'">You may link another file from your device or select those that have already been uploaded</span>

  <div class="gray-banner" [dataSelector]="dataSelector + '-selected-files-banner'">
    <div class="banner-left" [dataSelector]="dataSelector + '-banner-left'">
      <span class="h4-500" [dataSelector]="dataSelector + '-selected-files-label'">Selected files</span>
      <span class="h1-600 file-count" [dataSelector]="dataSelector + '-file-count'">{{ selectedFilesId.length }} file{{ selectedFilesId.length === 1 ? '' : 's' }}</span>
    </div>

    <div>
      <button
        [disabled]="selectedFilesId.length === 0"
        andButton
        color="ghost-secondary"
        [dataSelector]="dataSelector + '-clear-selection-button'"
        (click)="clearSelection()"
      >Clear Selection</button>
    </div>
  </div>

  <div class="file-list" [dataSelector]="dataSelector + '-file-list'">
    <div
      *ngFor="let file of (allFiles$ | async); let index = index"
      class="line-item line-item-actionable"
      [class]="{
        'line-item-selected': selectFileCheckbox.checked
      }"
      [dataSelector]="dataSelector + '-file-item-' + index"
      (click)="selectFile(file)"
    >
      <mat-checkbox
        #selectFileCheckbox
        [checked]="file.selected"
        class="d-flex"
        [disabled]="isMarkedForDeletion(file) || file.data.status === ClientRequestDocumentFileDisplayStatus.UPLOADING"
        [dataSelector]="dataSelector + '-file-checkbox-' + index"
        (click)="selectFile(file, $event)"
      >
        {{ file.data.name }}
      </mat-checkbox>

      <div class="line-item-addon body-300" [dataSelector]="dataSelector + '-file-actions-' + index">
        <ng-container *ngIf="file.data.status === ClientRequestDocumentFileDisplayStatus.UPLOADING">{{ file.data.status }}...</ng-container>

        <button
          andButton
          color="ghost"
          size="small"
          [disabled]="isMarkedForDeletion(file) || file.data.status === ClientRequestDocumentFileDisplayStatus.UPLOADING"
          [dataSelector]="dataSelector + '-delete-file-button-' + index"
          (click)="deleteFile(file, $event)"
        >
          <aiwyn-icon name="trash-2"></aiwyn-icon>
        </button>
      </div>
    </div>
  </div>

  <app-dialog-footer [showCancel]="false" [dataSelector]="dataSelector + '-footer'">
    <div class="w-100 d-flex justify-content-between">
      <button
        andButton
        color="default"
        type="button"
        [dataSelector]="dataSelector + '-cancel-button'"
        (click)="onClose()"
      >
        Cancel
      </button>

      <button
        andButton
        color="primary"
        type="button"
        [isLoading]="isLoading"
        [disabled]="!(hasChanges$ | async)"
        [dataSelector]="dataSelector + '-update-links-button'"
        (click)="updateLinks()"
      >
        Update Links
      </button>
    </div>
  </app-dialog-footer>
</app-dialog>
